import * as React from "react";

function Positions({ color = "var(--color-blue-500)", ...props }) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.675.172h-.35c-.746 0-1.37 0-1.88.06-.54.064-1.026.203-1.463.53-.435.325-.711.753-.937 1.256-.202.452-.388 1.021-.608 1.702-.399.022-.767.054-1.106.1-1.121.154-2.034.479-2.753 1.212-.716.73-1.032 1.654-1.182 2.79C.25 8.926.25 10.337.25 12.117v.11c0 1.78 0 3.19.146 4.295.15 1.136.466 2.06 1.182 2.79.72.733 1.632 1.057 2.753 1.211 1.086.149 2.473.149 4.217.149h1.459a.75.75 0 000-1.5H8.605c-1.814 0-3.098-.002-4.07-.135-.95-.13-1.491-.373-1.886-.775-.397-.405-.638-.962-.766-1.936-.131-.995-.133-2.307-.133-4.154 0-1.848.002-3.16.133-4.154.128-.975.37-1.531.766-1.936.395-.402.936-.645 1.886-.775.972-.133 2.256-.135 4.07-.135h3.803c1.814 0 3.098.002 4.071.135.95.13 1.49.373 1.886.775.622.634.839 1.613.885 3.855a.75.75 0 101.5-.03c-.045-2.176-.223-3.763-1.315-4.875-.719-.733-1.631-1.058-2.752-1.211a13.85 13.85 0 00-1.121-.101c-.22-.681-.405-1.25-.608-1.702-.225-.503-.501-.931-.936-1.256-.438-.327-.924-.466-1.464-.53-.51-.06-1.133-.06-1.879-.06zm3.295 3.504a11.26 11.26 0 00-.384-1.044c-.17-.377-.312-.554-.466-.669-.152-.113-.352-.195-.742-.241-.41-.049-.946-.05-1.747-.05h-.263c-.8 0-1.336.001-1.746.05-.39.046-.59.128-.742.241-.154.115-.297.292-.466.67-.121.27-.24.605-.385 1.043.473-.004.98-.004 1.52-.004h3.916c.535 0 1.036 0 1.505.004z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 16.448a4.276 4.276 0 117.782 2.45l1.497 1.493a.75.75 0 11-1.059 1.062l-1.5-1.495a4.276 4.276 0 01-6.72-3.51zm4.276-2.776a2.777 2.777 0 100 5.553 2.777 2.777 0 000-5.553z"
        fill={color}
      />
    </svg>
  );
}

export default Positions;
